import { getHttpClient } from '../axiosInstance'

const base = 'manager/users/v1'

export const load = async () => {
  const apiClient = getHttpClient()
  const url = `${base}/user`

  const response = await apiClient.get(url)
  return response.data
}

export const createEventNotAvailable = async (form) => {
  const apiClient = getHttpClient()
  const url = `${base}/event`

  const response = await apiClient.post(url, form)
  return response.data
}

export const dismissEvent = async (eventId) => {
  const apiClient = getHttpClient()
  const url = `${base}/dismiss-event/${eventId}`

  const response = await apiClient.put(url, {})
  return response.data
}
